// You can write more code here

/* START OF COMPILED CODE */

import EditorPlatformMarkerImage from "../../../EditorPlatformMarkerImage";
import PlatformFoliage3 from './../../../platforms/jungle/PlatformFoliage3';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class PlatformMarkerFoliage3 extends EditorPlatformMarkerImage {

  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 181.5, y ?? 42.5, texture || 'game-all', frame ?? "foliage-03.png");

    /* START-USER-CTR-CODE */
    this.classType = PlatformFoliage3;
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
